import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconCrown = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconCrown",
  viewBox: "0 0 18 19",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "m1.5 5.84.92 5.93h13.17l.9-5.93a.5.5 0 0 0-.78-.47L12.87 7.5a.7.7 0 0 1-.98-.17L9.53 3.78a.63.63 0 0 0-1.05 0L6.1 7.33a.7.7 0 0 1-.98.17L2.3 5.37a.5.5 0 0 0-.78.47Zm14.09 7.03H2.42v1.5a.7.7 0 0 0 .68.7h11.8a.7.7 0 0 0 .68-.7z"
  })
}));
IconCrown.displayName = 'IconCrown';